module.exports = __webpack_public_path__ + "media/images/sales/early/text-mv-copy-2-083f63169379e851a0e62193e62ca42b.svg";